import { Link } from "react-router-dom";
import { Monogram } from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#F7F5F1]/10 bg-[#26282E]">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-12">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <Monogram size={36} />
              <span className="font-serif text-lg tracking-[0.14em] text-[#F7F5F1]">CREDIBLE PRESENCE</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#C4BFB4]">
              Executive voice and communication coaching for leaders whose words carry weight. Based in Austin,
              Texas — working with clients in person and virtually, worldwide.
            </p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#E3D9C8]">Explore</p>
            <ul className="mt-5 space-y-3 text-sm text-[#C4BFB4]">
              <li><Link data-testid="footer-link-about" className="hover:text-[#F7F5F1] transition-colors" to="/about">About the Consultant</Link></li>
              <li><Link data-testid="footer-link-services" className="hover:text-[#F7F5F1] transition-colors" to="/services">Services</Link></li>
              <li><Link data-testid="footer-link-assessment" className="hover:text-[#F7F5F1] transition-colors" to="/assessment">Executive Presence Self-Assessment</Link></li>
              <li><Link data-testid="footer-link-contact" className="hover:text-[#F7F5F1] transition-colors" to="/contact">Request a Confidential Consultation</Link></li>
              <li><Link data-testid="footer-link-privacy" className="hover:text-[#F7F5F1] transition-colors" to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#E3D9C8]">Studio</p>
            <p className="mt-5 text-sm leading-relaxed text-[#C4BFB4]">
              Austin, Texas
              <br />
              In-person &amp; virtual sessions
              <br />
              crediblepresence.com
            </p>
            <p className="mt-6 text-xs leading-relaxed text-[#8A8D94]">
              All inquiries are confidential. The Executive Presence Self-Assessment is a self-reflection tool —
              it is not medical advice, diagnosis, or treatment.
            </p>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-[#F7F5F1]/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#8A8D94]">
            © 2026 Credible Presence. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#8A8D94]">
            Sound as credible as you are.
          </p>
        </div>
      </div>
    </footer>
  );
}
